import React from "react";
import QRCode from "react-qr-code";
import Overlay from "../Overlay";
import FilterCard, {FIELD_TYPE} from "../FilterCard";
import ReactToPrint from "react-to-print";
import Barcode from "react-barcode";
import {sweetalert} from "../../App";
import Validator, {ValidationEntry} from "../../validation/Validator";
import {Validators} from "../../validation/Validators";
import AdminAPI from "../../network/AdminAPI";
import Select from "react-select";
import ServicesAPI from "../../network/ServicesAPI";
import { getSelectLabels } from "../../util/FormatUtil";

interface SpecimenState{
    numberSpecimen: string
    filter: object
    show_loading: boolean
    specimenList: []
    barcodeStyleIs1D: boolean
    services
    serviceLabels
    selectedService
}

export class InternalSpecimen extends React.Component<any,SpecimenState>{
    private componentRef: any;
    
    constructor(props) {
        super(props);
        this.state = {
            filter: {},
            show_loading: false,
            numberSpecimen: '',
            specimenList: [],
            barcodeStyleIs1D: true,
            services: [],
            serviceLabels: [],
            selectedService: null
        };

        this.assignClearState = this.assignClearState.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
}

    componentDidMount() {
        this.setState({show_loading: true}, () => {
            ServicesAPI.getAllServicesForApptForm().then(response => {
                //get only enabled
                let enabledServices = response.data.filter(f => f.IsEnabled);
                this.setState({
                    services: enabledServices,
                    serviceLabels: getSelectLabels(enabledServices),
                    show_loading:false
                });
            })
        })
    }

    clearFilterState:() => void = null;


    assignClearState(func){
        this.clearFilterState = func;
    }

    clearState = () =>{
        this.clearFilterState();
    }
    
    handleServiceChange(event){
        this.clearState()
        this.setState({
            specimenList:[],
            selectedService: this.state.services.find(s => { return s.ID === event.value }),
        }, ()=>{
            let idSettings = JSON.parse(this.state.selectedService.SpecimenIdSettings);
            let barcodeType = idSettings[0].BarcodeType // this is a JSON_ARRAY in MYSQL
            this.setState({barcodeStyleIs1D: barcodeType === '2D' ? false : true})
        });
    }

    async onSubmit(e) {

        let formValidation = {
            Service: this.state.selectedService,
            NumberSpecimen: this.state.filter['numberSpecimen']
        }

        let validator = new Validator<any>()
            .withSimpleValidation("Service", Validators.requireNonNullValidator("Service"))
            .withComposedValidation("NumberSpecimen", new ValidationEntry(Validators.requireNotBlankValidator("Number of Labels")), new ValidationEntry(Validators.requireRange(1,100, "Number of Labels")), new ValidationEntry(Validators.requireIsInt("Number of Labels")))
        let validationResponse = validator.validate(formValidation);
        if(!validationResponse.success) {
            return sweetalert.fire({icon: 'error', title: '', text: validationResponse.error});
        }
        this.setState({show_loading: true, numberSpecimen: this.state.filter['numberSpecimen']})

        try{
            let result = await AdminAPI.getSpecimenLabels({serviceID: this.state.selectedService.ID, count: this.state.filter['numberSpecimen']})
            if(result.success){
                this.setState({specimenList: result.idList, show_loading: false});
            }
        }
        catch (e) {
            console.error(e);
            this.setState({show_loading: false});
        }
    }

    buildTableOfBarcodes(){
        if(this.state.selectedService.ReportType === 1){
            return (
                this.state.specimenList.map((specimenID) => (
                    <>
                        <table className={"simpleLabel"}>
                            <tr className={'mt-4'}>
                                {this.state.barcodeStyleIs1D ?
                                    <td><b> <Barcode width={4} height={100} value={specimenID} /> </b></td> :
                                    <td className={'text-center'}>
                                        <QRCode value={specimenID} size={50} />
                                        <div className={'mt-2'}>{specimenID}</div>
                                    </td>
                                }
                            </tr>
                        </table>
                    </>
                ))
            )
        } else {
            // HR5 Periodontal Service gets 4 labels per specimen ID
            // others get one label per specimen ID
            return (
                <div className="perioLabelGrid">
                { this.state.specimenList.map((specimenID) => (
                    // <div className="perioLabelGrid">
                    <tr className={"row"}>
                        {/* first label barcode, label, specimen id*/}
                        {this.state.barcodeStyleIs1D ?
                            <td><b> <Barcode width={4} height={100} value={specimenID} /> </b></td> :
                            <td className={'column'} id="label_one">
                                <div style={{"display":"flex"}}>
                                    <span style={{"marginTop":"6px"}}><QRCode value={specimenID} size={44} /></span>
                                    <span className={""} style={{"marginLeft":"16px","maxWidth":"110px"}}>
                                        OraPath Saliva Collection Kit
                                        </span>
                                </div>
                                <div>
                                    Sample ID# <b>{specimenID}</b>
                                </div>
                            </td>
                        }
                        {/* label 2-4 barcode, specimen id, date, name, dob, */}
                        {this.state.barcodeStyleIs1D ?
                            <td><b> <Barcode width={4} height={100} value={specimenID} /> </b></td> :
                            <td className={'column'} id="label_two">
                                <div className={""} style={{"display":"flex","marginLeft":"2px"}}>
                                    <div style={{"marginTop":"6px", "marginRight":"3px"}}>
                                        <div  className={"ml-1"}><QRCode value={specimenID} size={44} /></div>
                                        <div className={''} style={{ "fontSize": "smaller", "marginTop":"2px" }}>{specimenID}</div>
                                    </div>
                                    <div className={""} >
                                        <div style={{ "fontSize": "smaller","marginTop":"2px"}}>Date: ______/______/______ </div>
                                        <div style={{ "fontSize": "smaller", "marginTop":"4px" }}>Name: __________________ </div>
                                        <div style={{ "fontSize": "smaller", "marginTop":"4px" }}>DOB: ______/______/______ </div>
                                    </div>
                                </div>
                            </td>
                        }
                        {this.state.barcodeStyleIs1D ?
                            <td><b> <Barcode width={4} height={100} value={specimenID} /> </b></td> :
                            <td className={'column'} id="label_three">
                                <div className={""} style={{"display":"flex","marginLeft":"2px"}}>
                                    <div style={{"marginTop":"6px","marginRight":"3px"}}>
                                        <div className={"ml-1"}><QRCode value={specimenID} size={44} /></div>
                                        <div className={''} style={{ "fontSize": "smaller", "marginTop":"2px" }}>{specimenID}</div>
                                    </div>
                                    <div className={""}>
                                        <div style={{ "fontSize": "smaller","marginTop":"2px"}}>Date: ______/______/______ </div>
                                        <div style={{ "fontSize": "smaller", "marginTop":"4px" }}>Name: __________________ </div>
                                        <div style={{ "fontSize": "smaller", "marginTop":"4px" }}>DOB: ______/______/______ </div>
                                    </div>
                                </div>
                            </td>
                        }
                        {this.state.barcodeStyleIs1D ?
                            <td><b> <Barcode width={4} height={100} value={specimenID} /> </b></td> :
                            <td className={'column'} id="label_four">
                                <div className={""} style={{"display":"flex","marginLeft":"2px"}}>
                                    <div style={{"marginTop":"6px", "marginRight":"3px"}}>
                                        <div className={"ml-1"}><QRCode value={specimenID} size={44} /></div>
                                        <div className={''} style={{ "fontSize": "smaller", "marginTop":"2px" }}>{specimenID}</div>
                                    </div>
                                    <div className={""}>
                                        <div style={{ "fontSize": "smaller","marginTop":"2px"}}>Date: ______/______/______ </div>
                                        <div style={{ "fontSize": "smaller", "marginTop":"4px" }}>Name: __________________ </div>
                                        <div style={{ "fontSize": "smaller", "marginTop":"4px" }}>DOB: ______/______/______ </div>
                                    </div>
                                </div>
                            </td>
                        }
                    </tr>
                ))
                } 
            </div>
            )
        }
    }

    getPageMargins(){ // react to print: let user define margin
        let marginTop = "48px"
        let marginRight = "36px"
        let marginBottom = "48px"
        let marginLeft = "36px"

        return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
      }


render() {
    return(
        <React.Fragment>
                <Overlay show_loading={this.state.show_loading}/>
                <div className="container-fluid">
                    <div className={"row"}>
                        <div className="col-12 col-md-12 col-xl-8 col-lg-8 pt-2">
                            <div className="card mb-2">
                                <div className="card-header verlag-bold">
                                    <h4>Print Specimen Labels</h4>
                                </div>

                            <div className="card-body">
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label" style={{ fontWeight: 'bold' }}>Service</label>
                                    <div className="col-sm-8  p-0 m-0">
                                        <Select
                                            isMulti={false}
                                            isSearchable={true}
                                            placeholder={"Please Select a Service..."}
                                            noOptionsMessage={() => "No options"}
                                            className={"state_select"}
                                            options={this.state.serviceLabels}
                                            onChange={(e) => this.handleServiceChange(e)}
                                        />
                                    </div>
                                </div>
                                    <FilterCard
                                        fields={[
                                            {
                                                key: "numberSpecimen",
                                                label: "Number of Labels",
                                                type: FIELD_TYPE.NUMBER,
                                                isMapped: true
                                            },
                                        ]}
                                        filterChanged={(filter) => this.setState({ filter: filter })} 
                                        passClearStateFunc={this.assignClearState}
                                    />
                                </div>
                                <div className="card-footer">
                                    <button
                                        className="btn immySubmitButtonOutline"
                                        onClick={(e) => this.onSubmit(e)}>
                                        View Labels
                                    </button>

                                    {this.state.numberSpecimen ? <ReactToPrint
                                        trigger={() => <button className={"btn btn-outline-success"} style={{float: 'right'}}>Print Labels</button>}
                                        // @ts-ignore
                                        content={() => this.componentRef}
                                    /> : <ReactToPrint
                                        trigger={() => <button className={"btn btn-outline-success"} style={{float: 'right', display: 'none'}}>Print Labels</button>}
                                        // @ts-ignore
                                        content={() => this.componentRef}
                                    />}
                                </div>
                            </div>
                            <div ref={el => (this.componentRef = el)} id="our-react-to-print-div" >
                                <style>{this.getPageMargins()}</style>
                                <table className={this.state.selectedService && this.state.selectedService.ReportType > 1 ? "perioLabels" : ""}>
                                    {this.state.selectedService &&
                                        this.buildTableOfBarcodes()
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
        </React.Fragment>
        )
    }
}